export default "__VITE_ASSET__CkmSMrYc__"